import React from "react";
import ParkingSlotCategoryPreview from "../ParkingSlotCategoryPreview";

const ParkingSlotPreview = ({
  parkingSlot,
  colors,
  onClick = null,
  selected = false,
  className = "",
}) => {
  return (
    <ParkingSlotCategoryPreview
      parkingSlotCategory={parkingSlot.category}
      name={parkingSlot.name}
      price={parkingSlot.price}
      colors={colors}
      onClick={onClick}
      selected={selected}
      className={className}
    />
  );
};

export default ParkingSlotPreview;
